exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customDatePickerWidth,.customDatePickerWidth>div.react-datepicker-wrapper,.customDatePickerWidth>div>div.react-datepicker__input-container,.customDatePickerWidth>div>div.react-datepicker__input-container input{width:100%;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/calendar/calendareventdatepickers.scss
// module id = 4604
// module chunks = 0